import { TABS } from "@/config";
import { useMainStore, useStore } from "@/store";
import Signalr from "@/utils/signalr";
import { watch, nextTick } from "vue";
import { isWatch } from "./useLogin";
export interface Obj {
  isZt?: boolean;
  isSignalr?: boolean;
  immediate?: boolean;
  isLatestZt?: boolean;
}
export type Callback = () => void;

export default (tab = TABS.CLIENT, fn: Callback, obj?: Obj): void => {
  const { isZt = false, isSignalr = false, immediate = true, isLatestZt = false } = obj || {};
  const mainStore = useMainStore();
  const store = useStore();
  let unWatch: { (): void; call?: any } | null;

  /** 安装监听 */
  const onInstall = async () => {
    await store.setNowUserinfo();
    unWatch = watch(
      () => (isZt ? mainStore.getZtToken(isLatestZt) : mainStore.nowCustomer),
      async (v, o) => {
        if (!isWatch) return;
        if (!v && isZt) {
          await mainStore.setToken(isLatestZt, tab == TABS.NETFILE);
        } else {
          if (isSignalr) Signalr(v.replace("Bearer ", ""));
          nextTick(fn);
        }
      },
      { immediate }
    );
  };

  watch(
    () => store.active,
    (v) => {
      if (!isWatch) return;
      if (v == tab) {
        console.log(`监听:`, tab);
        onInstall();
      } else {
        if (!unWatch) return;
        console.log("卸载:", tab);
        unWatch?.call();
        unWatch = null;
      }
    },
    { immediate: true }
  );
};
